/* clupp. — comportamiento de las secciones de marca.
   Se re-inicializa en cada carga de seccion del editor de temas, para que
   el marquee y la cuenta regresiva sigan vivos al editar. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initTicker(root) {
    if (reduce) return;
    root.querySelectorAll('.clupp-ticker__track').forEach(function (track) {
      if (track.dataset.cluppDoubled === 'true') return;
      track.dataset.cluppDoubled = 'true';
      track.insertAdjacentHTML('beforeend', track.innerHTML);
    });
  }

  function initClock(root) {
    root.querySelectorAll('[data-clupp-clock]').forEach(function (clock) {
      var raw = clock.getAttribute('data-clupp-clock');
      if (!raw) return;

      /* La fecha se escribe como AAAA-MM-DD en el editor. Se ancla a la
         medianoche de Lima (UTC-5) para que la cuenta sea la misma sin
         importar desde donde se mire. */
      var target = Date.parse(raw.indexOf('T') === -1 ? raw + 'T00:00:00-05:00' : raw);
      if (isNaN(target)) return;

      if (clock.dataset.cluppTimer) clearInterval(Number(clock.dataset.cluppTimer));

      var tick = function () {
        var left = Math.max(0, target - Date.now());
        var vals = {
          d: Math.floor(left / 86400000),
          h: Math.floor(left / 3600000) % 24,
          m: Math.floor(left / 60000) % 60
        };
        Object.keys(vals).forEach(function (k) {
          var el = clock.querySelector('[data-u="' + k + '"]');
          if (el) el.textContent = String(vals[k]).padStart(2, '0');
        });
      };

      tick();
      clock.dataset.cluppTimer = String(setInterval(tick, 30000));
    });
  }

  function init(root) {
    initTicker(root || document);
    initClock(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Shopify vuelve a inyectar el HTML de una seccion al editarla. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
